import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";
import Button from "../../../../Custom/Button/Button";
import deleteImg from "../../../../../picture/delete.png";
import ButtonsPocetna from "./ButtonsPocetna";
import ButtonsEdit from "./ButtonsEdit";
import ButtonsAddItem from "./ButtonsAddItem";
import { QRCodeSVG } from "qrcode.react";

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold" },
  cell: { padding: "5px", textAlign: "center" },
  cellHeader: { padding: "5px", textAlign: "center", backgroundColor: "#ccc" },
  smallCell: { width: "40px", textAlign: "center" },
};

const formatDatum = (datum) => {
  if (!datum) return null;
  const d = new Date(datum);
  if (isNaN(d)) return datum;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}.`;
};

function ListaInventara({ sredstvoId, close }) {
  const [data, setData] = useState(null);
  const [newData, setNewData] = useState(null);
  const [currentState, setCurrentState] = useState("");

  const { dictionary, baseUrl } = useGlobalContext();

  const fetchData = () => {
    if (!sredstvoId) return;
    axios
      .get(`${baseUrl}/machines/get_one.php?masina_id=${sredstvoId}`)
      .then(({ data: res }) => {
        if (res.status === 200) {
          setData(res.data);
          setNewData(res.data);
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchData();
  }, [sredstvoId]);

  const handlePovecajKom = (stavkaId) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.map((s) =>
        s.id === stavkaId
          ? { ...s, kolicina_trenutna: Number(s.kolicina_trenutna) + 1 }
          : s,
      ),
    }));
  };

  const handleSmanjiKom = (stavkaId) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.map((s) =>
        s.id === stavkaId && s.kolicina_trenutna > 0
          ? { ...s, kolicina_trenutna: Number(s.kolicina_trenutna) - 1 }
          : s,
      ),
    }));
  };

  const handleObrisiStavku = async (stavkaId) => {
    try {
      await axios.post(`${baseUrl}/spp/delete_stavka.php`, {
        stavka_id: stavkaId,
      });
      setNewData((prev) => ({
        ...prev,
        stavke: prev.stavke.filter((s) => s.id !== stavkaId),
      }));
    } catch (e) {
      console.error(e);
    }
  };

 const handlePrint = () => {
  if (!newData) return;

  const fotoUrl = newData.foto_path
    ? `${baseUrl.replace("/api", "")}/${newData.foto_path}`
    : null;
  const snUrl = newData.strucni_nalaz_path
    ? `${baseUrl.replace("/api", "")}${newData.strucni_nalaz_path}`
    : null;
    
  const qrValue = snUrl || `masina_${newData.masina_id}`;

  const w = window.open("", "_blank");
  if (!w) return;

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <style>
    body { font-family: sans-serif; padding: 10mm; background: #fff; }
    @page { size: A4 portrait; margin: 0; }
    
    .container { display: flex; gap: 15px; background: white; }
    .column { width: 50%; }
    
    /* Identicni stilovi kao u tvom React kodu */
    table { width: 100%; border-collapse: collapse; margin-bottom: 10px; border: 1px solid #9f9f9f; }
    th { padding: 5px; text-align: center; background-color: #ccc; border: 1px solid #9f9f9f; font-size: 12px; }
    td { padding: 5px; text-align: center; border: 1px solid #9f9f9f; font-size: 12px; }
    
    .foto-box { 
      border: 1px solid #ccc; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      min-height: 250px; 
      margin-top: 10px; 
    }
    .foto-box img { max-width: 100%; max-height: 250px; object-fit: contain; }
    
    .uputstvo-napomena { 
      text-align: left !important; 
      white-space: pre-wrap; 
    }
    
    .qr-cell { 
      width: 70px; 
      vertical-align: middle; 
      text-align: center; 
    }
    
    .alert-row { background-color: #fff3cd !important; -webkit-print-color-adjust: exact; }
  </style>
</head>
<body>
  <div class="container">
    
    <div class="column">
      <table>
        <tr>
          <th colspan="2">${dictionary["vrsta"] || "Врста"}</th>
          <th colspan="2">${dictionary["tip"] || "Тип"}</th>
        </tr>
        <tr>
          <td colspan="2">${newData.vrsta_naziv || "—"}</td>
          <td colspan="2">${newData.tip || "—"}</td>
        </tr>
        <tr>
          <th colspan="2">${dictionary["oznaka"] || "Ознака"}</th>
          <th colspan="2">${dictionary["lokacija"] || "Локација"}</th>
        </tr>
        <tr>
          <td colspan="2">${newData.oznaka || "—"}</td>
          <td colspan="2">${newData.lokacija || "—"}</td>
        </tr>
      </table>

      <table>
        <tr>
          <th colspan="3">${dictionary["strucniNalaz"] || "Стручни налаз"}</th>
          <th rowspan="3" class="qr-cell">
            <img src="https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=${encodeURIComponent(qrValue)}" width="60" height="60" />
          </th>
        </tr>
        <tr>
          <th colspan="2">${dictionary["brojNalaza"] || "Број налаза"}</th>
          <th>${dictionary["istice"] || "Истиче"}</th>
        </tr>
        <tr>
          <td colspan="2">${newData.strucni_nalaz_broj || "—"}</td>
          <td>${formatDatum(newData.strucni_nalaz_istice) || "—"}</td>
        </tr>
      </table>

      <div class="foto-box">
        ${fotoUrl ? `<img src="${fotoUrl}" />` : `<span style="color: #aaa;">${dictionary["nepostojiFotografija"] || "Нема фотографије"}</span>`}
      </div>

      ${newData.napomena ? `
      <table>
        <tr><th>${dictionary["napomena"] || "Напомена"}</th></tr>
        <tr><td class="uputstvo-napomena">${newData.napomena}</td></tr>
      </table>` : ""}
    </div>

    <div class="column">
      ${newData.stavke && newData.stavke.length > 0 ? `
      <table>
        <thead>
          <tr>
            <th>${dictionary["rb"] || "Рб."}</th>
            <th style="width: 70%;">${dictionary["sadrzaj"] || "Садржај"}</th>
            <th>${dictionary["kom"] || "Ком."}</th>
          </tr>
        </thead>
        <tbody>
          ${newData.stavke.map((s, i) => `
            <tr class="${Number(s.kolicina_trenutna) < Number(s.kolicina_min) ? 'alert-row' : ''}">
              <td>${i + 1}.</td>
              <td>${s.naziv || s.sadrzaj || ""}</td>
              <td>${s.kolicina_trenutna ?? s.kom ?? 0}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>` : ""}

      ${newData.uputstvo ? `
      <table>
        <tr><th>${dictionary["uputstvo"] || "Упутство за употребу"}</th></tr>
        <tr><td class="uputstvo-napomena">${newData.uputstvo}</td></tr>
      </table>` : ""}
    </div>

  </div>

  <script>
    window.onload = () => {
      setTimeout(() => {
        window.print();
        window.onafterprint = () => window.close();
      }, 500);
    };
  </script>
</body>
</html>`;

  w.document.write(html);
  w.document.close();
};
  if (!data || !newData)
    return <div style={{ padding: "20px" }}>Учитавање...</div>;

  const fotoUrl = newData.foto_path
    ? `${baseUrl.replace("/api", "")}/${newData.foto_path}`
    : null;

  const snUrl = newData.strucni_nalaz_path
    ? `${baseUrl.replace("/api", "")}${newData.strucni_nalaz_path}`
    : null;

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          background: "white",
          border: "1.5px solid #9f9f9f",
          padding: "10px",
          gap: "15px",
        }}
      >
        {/* LEVA KOLONA: Osnovni podaci, Nalaz, Foto, Napomena */}
        <div style={{ width: "50%" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={styles.cellHeader} colSpan={2}>
                  {dictionary["vrsta"] || "Врста"}
                </th>
                <th style={styles.cellHeader} colSpan={2}>
                  {dictionary["tip"] || "Тип"}
                </th>
              </tr>
              <tr>
                <td style={styles.cell} colSpan={2}>
                  {newData.vrsta_naziv || "—"}
                </td>
                <td style={styles.cell} colSpan={2}>
                  {newData.tip || "—"}
                </td>
              </tr>
              <tr>
                <th style={styles.cellHeader} colSpan={2}>
                  {dictionary["oznaka"] || "Ознака"}
                </th>
                <th style={styles.cellHeader} colSpan={2}>
                  {dictionary["lokacija"] || "Локација"}
                </th>
              </tr>
              <tr>
                <td style={styles.cell} colSpan={2}>
                  {newData.oznaka || "—"}
                </td>
                <td style={styles.cell} colSpan={2}>
                  {newData.lokacija || "—"}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Stručni nalaz & QR Kod */}
          {newData.strucni_nalaz_broj && (
            <table style={{ width: "100%", marginTop: "10px" }}>
              <tbody>
                <tr>
                  <th style={styles.cellHeader} colSpan={3}>
                    {dictionary["strucniNalaz"] || "Стручни налаз"}
                  </th>
                  <th
                    rowSpan={3}
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      border: "1px solid #ccc",
                      width: "70px",
                    }}
                  >
                    <QRCodeSVG
                      value={snUrl || `masina_${newData.masina_id}`}
                      size={60}
                    />
                  </th>
                </tr>
                <tr>
                  <th style={styles.cellHeader} colSpan={2}>
                    {dictionary["brojNalaza"] || "Број налаза"}
                  </th>
                  <th style={styles.cellHeader}>
                    {dictionary["istice"] || "Истиче"}
                  </th>
                </tr>
                <tr>
                  <td style={styles.cell} colSpan={2}>
                    {newData.strucni_nalaz_broj}
                  </td>
                  <td style={styles.cell}>
                    {formatDatum(newData.strucni_nalaz_istice) || "—"}
                  </td>
                </tr>
                {snUrl && (
                  <tr>
                    <td
                      colSpan={4}
                      style={{ ...styles.cell, textAlign: "left" }}
                    >
                      <a
                        href={snUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{ fontSize: "12px" }}
                      >
                        Погледај стручни налаз
                      </a>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          {/* Foto */}
          <div
            style={{
              border: "1px solid #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "200px",
              marginTop: "10px",
            }}
          >
            {fotoUrl ? (
              <img
                src={fotoUrl}
                style={{
                  maxWidth: "100%",
                  maxHeight: "250px",
                  objectFit: "contain",
                }}
                alt="Masina"
              />
            ) : (
              <span style={{ color: "#aaa", fontSize: "13px" }}>
                {dictionary["nepostojiFotografija"] || "Нема фотографије"}
              </span>
            )}
          </div>

          {/* Napomena - SADA NA LEVOJ STRANI ISPOD SLIKE */}
          {newData.napomena && (
            <table style={{ width: "100%", marginTop: "10px" }}>
              <tbody>
                <tr>
                  <th style={styles.cellHeader}>
                    {dictionary["napomena"] || "Напомена"}
                  </th>
                </tr>
                <tr>
                  <td
                    style={{
                      ...styles.cell,
                      textAlign: "left",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {newData.napomena}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        {/* DESNA KOLONA: Inventar (Stavke) i Uputstvo */}
        <div style={{ width: "50%" }}>
          {/* Inventar / Stavke */}
          {newData.stavke && newData.stavke.length > 0 && (
            <div style={{ marginBottom: "15px" }}>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={styles.cellHeader}>
                      {dictionary["rb"] || "Рб."}
                    </th>
                    <th style={{ ...styles.cellHeader, width: "70%" }}>
                      {dictionary["sadrzaj"] || "Садржај"}
                    </th>
                    <th style={styles.cellHeader}>
                      {dictionary["kom"] || "Ком."}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {newData.stavke.map((stavka, index) => (
                    <tr
                      key={stavka.id}
                      style={{
                        backgroundColor:
                          Number(stavka.kolicina_trenutna) <
                          Number(stavka.kolicina_min)
                            ? "#fff3cd"
                            : "transparent",
                      }}
                    >
                      <td style={styles.cell}>{index + 1}.</td>
                      <td style={styles.cell}>
                        {stavka.naziv || stavka.sadrzaj}
                      </td>
                      <td style={styles.cell}>
                        {currentState !== "EDIT" ? (
                          (stavka.kolicina_trenutna ?? stavka.kom)
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              gap: "2px",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            {stavka.custom && stavka.kolicina_trenutna === 0 ? (
                              <div
                                onClick={() => handleObrisiStavku(stavka.id)}
                              >
                                <Button activation={true}>
                                  <img
                                    src={deleteImg}
                                    style={{ width: "20px" }}
                                    alt="del"
                                  />
                                </Button>
                              </div>
                            ) : (
                              <div onClick={() => handleSmanjiKom(stavka.id)}>
                                <Button
                                  activation={true}
                                  style={{ padding: "0px 5px" }}
                                >
                                  -
                                </Button>
                              </div>
                            )}
                            <span>
                              {stavka.kolicina_trenutna ?? stavka.kom}
                            </span>
                            <div onClick={() => handlePovecajKom(stavka.id)}>
                              <Button
                                activation={true}
                                style={{ padding: "0px 3px" }}
                              >
                                +
                              </Button>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                  {currentState === "EDIT" && (
                    <tr>
                      <td colSpan={2}></td>
                      <td
                        onClick={() => setCurrentState("ADD_ITEM")}
                        style={{ textAlign: "center" }}
                      >
                        <Button activation={true}>+</Button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Uputstvo - SADA NA DESNOJ STRANI */}
          {newData.uputstvo && (
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <th style={styles.cellHeader}>
                    {dictionary["uputstvo"] || "Упутство за употребу"}
                  </th>
                </tr>
                <tr>
                  <td
                    style={{
                      ...styles.cell,
                      textAlign: "left",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {newData.uputstvo}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Buttoni za akcije */}
      {currentState === "" && (
        <ButtonsPocetna
          cancelPreview={close}
          setCurrentState={setCurrentState}
          onPrint={handlePrint}
          data={newData}
        />
      )}
      {currentState === "EDIT" && (
        <ButtonsEdit
          setCurrentState={setCurrentState}
          newData={newData}
          setNewData={setNewData}
          data={data}
          setData={setData}
          onRefresh={fetchData}
        />
      )}
      {currentState === "ADD_ITEM" && (
        <ButtonsAddItem
          setCurrentState={setCurrentState}
          setNewData={setNewData}
          sredstvoId={sredstvoId}
        />
      )}
    </div>
  );
}

export default ListaInventara;
